module.exports = __webpack_public_path__ + "img/tempctrl_off.9b770f2d.png";